export const updateHeader=(headers, key, value) =>{
    // Search for the key in the headers list
    const index = headers.findIndex(header => header.key === key);

    // If the key exists, update its value
    if (index !== -1) {
        headers[index].value = value;
    } else {
        // If the key doesn't exist, add a new key-value pair
        headers.push({ key, value });
    }
}
export const safeCreateIfEmptyHeaders=(action) =>{
 // Check if headers exists and if not, create an empty array
 if (!action.headers || !Array.isArray(action.headers)) {
    action.headers = [];
  }
}
export const getHeaderValueByKey=(headers,key) =>{
    //empty list
    if(!headers){
        return null;
    }
    const header = headers.find(header => header.key === key);
    //empty header
    if(!header){
        return null;
    }
    return header.value
    
}